import { render, staticRenderFns } from "./PerksContainer.vue?vue&type=template&id=c70c245e&scoped=true"
import script from "./PerksContainer.vue?vue&type=script&lang=js"
export * from "./PerksContainer.vue?vue&type=script&lang=js"
import style0 from "./PerksContainer.vue?vue&type=style&index=0&id=c70c245e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70c245e",
  null
  
)

export default component.exports